import ExportForm from "../common/ExportForm";
const EXPORT_COLUMNS = [
	{key:"labNumber", label: "Lab Number"}, 
	{key: "labNumberDate", label: "Lab Number Date"}, 
	{key: "organizationName", label: "Organization Name"}, 
	{key: "contactName", label: "Contact Name"},
	{key: "poNumber", label: "PO Number"}, 
	{key: "quoteNumber", label: "Quote Number"}, 
	{key: "deadline", label: "Deadline"}, 
	{key: "workOrderDate", label: "Work Order Date"}, 
	{key: "partsReceivedDate", label: "Parts Received Date"}, 
	{key: "workOrderStatus", label: "Work Order Status"},
	{key: "techs", label: "Technicians"}, 
	{key: "holdReason", label: "Hold Reason"},
	{key: "notes", label: "Notes"}, 
	{key: "void", label: "Void"},  
    {key: "voidReason", label: "Void Reason"}, 
    {key: "validateReason", label: "Validate Reason"}, 
    {key: "creatorName", label: "Creator"}, 
    {key: "createdAt", label: "Created At"}, 
    {key: "updaterName", label: "Updater"}, 
    {key: "updatedAt", label: "Updated At"}
];
export default function WorkOrderExportForm(){
	return (<ExportForm columns = {EXPORT_COLUMNS}/>);
}
